export default __webpack_public_path__ + "static/media/inicio.09f74632.jpg";